// Explanations shown next to the Performance, Readiness and CSS/MSS labels (HMY-102).
// Wording states no numeric thresholds; zone limits are only those drawn on the Readiness chart.
export const TERM_DEFINITIONS = {
    Stress:
        'Training Stress Score (TSS): how demanding a workout was, combining its duration and intensity relative to your Critical Swim Speed. Shown as bars.',
    Fitness:
        'Chronic Training Load (CTL): a long-term rolling average of your training stress. It rises slowly with consistent training and falls slowly when you rest.',
    Fatigue:
        'Acute Training Load (ATL): a short-term rolling average of your recent training stress. It rises quickly after hard training and drops quickly with rest.',
    Form:
        'Training Stress Balance (TSB): Fitness minus Fatigue. Positive values mean you are fresher than your fitness level; negative values mean fatigue is outweighing fitness.',
    Undertraining:
        'Acute:Chronic Workload Ratio (ACWR) in the undertraining zone: recent training load is low compared with the load you have built up, so fitness may be lost.',
    Overtraining:
        'Acute:Chronic Workload Ratio (ACWR) in the overtraining zone: recent training load is much higher than the load you have built up, which raises the risk of injury and excessive fatigue.',
    'Critical Swim Speed':
        'Critical Swim Speed (CSS): the fastest swimming speed you can theoretically sustain for a long time without exhaustion. It is the reference for your training zones and for Stress calculations.',
    'Maximal Swim Speed':
        'Maximal Swim Speed (MSS): your fastest all-out swimming speed over a short sprint. It is the reference for your anaerobic training zones.'
};
